import { CountryEnums, LanguageEnums } from "models/enums";

export const PaymentTerms = [10, 15, 30, 60];
export const VatTypes = [0, 6, 12, 25];
export const DefaultVatType = 25;
export const HighInvoiceAmountThresholdSEK = 5000000;
export const InvoiceCategoryNoClueAccount = 4;
export const DefaultInvoiceLanguageCode = LanguageEnums.LanguageCodes.SV;
export const DefaultInvoiceCountry = CountryEnums.CountryCode.SE;
export const Period = ["Monthly", "Yearly"];
export const CustomerRoutePropName = "customerName";
export const SaveToEmailAction = "saveToEmailAction";
export const AddCustomerAction = "addCustomerAction";
export const SerialNumberTemplateValue = "{fakturanummer}";
export const ReminderDueDaysTemplateValue = "{förfallodagar}";
export const ReminderDueDateTemplateValue = "{förfallodatum}";
export const ReminderDueDays = 10;
export const DefaultUnit = "st";
export const BICOptions = [
  { item: "SEB", value: "ESSESESS" },
  { item: "Swedbank", value: "SWEDSESS" },
  { item: "Handelsbanken", value: "HANDSESS" },
  { item: "Danske Bank", value: "DABASESX" },
  { item: "Nordea", value: "NDEASESS" },
];

export const DebounceDelay = 1500;
export const InvoiceHtmlId = "invoiceHtml";

export const InvoicesActicationInProgressErrorCode = "ActivationInProgress";
export const InvoicesAlreadyActivatedErrorCode = "AlreadyActivated";

/**
 * Codes Core raises when an invoice would book on an account that is not active. Only Wint can
 * activate the account, so these messages are shown with the support-case link (WintErrorDescriber).
 */
export const InactiveAccountErrorCodes = [
  "InvoiceVatFreeSalesAccountInactive",
  "InvoiceVatRateSalesAccountInactive",
  "InvoiceArticleAccountInactive",
  "InvoiceVatAccountInactive",
  "InvoiceAccountInactive",
];
